import './sprite'
import './test'
import './moving'
import * as Behaviours from 'alcumus-behaviours'
import {getGameObjects} from '../game-surface'

export function addGameObject(object, behaviours) {
    let result
    getGameObjects().push(result = createGameObject(object, behaviours))
    return result
}
function simpleClone(obj) {
    let output = {}
    for(let key in obj) {
        output[key] = {...obj[key]}
    }
    return output
}


export function createGameObject(object, behaviours={}) {
    Behaviours.initialize(object, simpleClone({sprite:{}, ...behaviours}))
    return object
}
